import { IAccessRequest } from 'interfaces/AccessRequest/IAccessRequest';
import { IAccessRequestUpdate } from 'interfaces/AccessRequest/IAccessRequestUpdate';
import { IDocument } from 'interfaces/HistoricalResults/IDocument';
import { useCallback } from 'react';
import { historicalResultsRoute } from '../../helpers/apiRoutes';
import { useApiCalls } from '../UseApiCalls';

export const HistoricalResultsApis = () => {
  const { getQuery, postQuery, postQueryFileDownload } = useApiCalls();

  const getAvailableClientResults = useCallback(() => {
    return getQuery(`${historicalResultsRoute}/get-available-client-results`);
  }, [getQuery]);

  const getAvailablePersonalResults = useCallback(() => {
    return getQuery(`${historicalResultsRoute}/get-available-personal-results`);
  }, [getQuery]);

  const getResults = useCallback(
    (regTid, branch) => {
      return getQuery(`${historicalResultsRoute}/get-results?regTid=${encodeURIComponent(regTid)}&branch=${encodeURIComponent(branch)}`);
    },
    [getQuery]
  );

  const getManagedClients = useCallback(() => {
    return getQuery(`${historicalResultsRoute}/get-managed-clients`);
  }, [getQuery]);

  const getAccess = useCallback(() => {
    return getQuery(`${historicalResultsRoute}/get-access`);
  }, [getQuery]);

  const getClientAccess = useCallback(
    (clRef, branch) => {
      return getQuery(`${historicalResultsRoute}/get-client-access?clRef=${encodeURIComponent(clRef)}&branch=${encodeURIComponent(branch)}`);
    },
    [getQuery]
  );

  const postRequestAccess = useCallback(
    (reportId) => {
      const data = {
        Id: reportId,
      };
      return postQuery(`${historicalResultsRoute}/request-access`, data);
    },
    [postQuery]
  );

  const getAccessDetails = useCallback((data: IAccessRequest) => {
    return fetch(`${historicalResultsRoute}/get-access-request-details?id=${encodeURIComponent(data.Id)}&token=${encodeURIComponent(data.Token)}&accessType=${encodeURIComponent(data.AccessType)}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((data) => data.json());
  }, []);

  const postSetAccess = useCallback((data: IAccessRequest) => {
    return fetch(`${historicalResultsRoute}/set-access`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    }).then((data) => data.json());
  }, []);

  const postUpdateAccess = useCallback(
    (data: IAccessRequestUpdate) => {
      return postQuery(`${historicalResultsRoute}/update-access`, data);
    },
    [postQuery]
  );

  const downloadReport = useCallback(
    (document: IDocument) => {
      return postQueryFileDownload(`${historicalResultsRoute}/download-file`, document);
    },
    [postQueryFileDownload]
  );

  const getClientJobsDashboard = useCallback(() => {
    return getQuery(`${historicalResultsRoute}/client-jobs-dashboard`);
  }, [getQuery])

  const getClientSpendDashboard = useCallback(() => {
    return getQuery(`${historicalResultsRoute}/client-spend-dashboard`);
  }, [getQuery])

  const getJobComplianceDashboard = useCallback(() => {
    return getQuery(`${historicalResultsRoute}/job-compliance-dashboard`);
  }, [getQuery])

  const getTurnAroundTimesDashboard = useCallback(() => {
    return getQuery(`${historicalResultsRoute}/turnaround-times-dashboard`);
  }, [getQuery])

  return {
    getAvailableClientResults,
    getAvailablePersonalResults,
    getResults,
    postUpdateAccess,
    postSetAccess,
    getAccess,
    getAccessDetails,
    getClientAccess,
    getManagedClients,
    postRequestAccess,
    downloadReport,
    getClientJobsDashboard,
    getClientSpendDashboard,
    getJobComplianceDashboard,
    getTurnAroundTimesDashboard,
  };
};
